import { Loan } from '@treasury/domain/loans/loan.entity';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './loan-payment-readonly';

export const tagName = 'loan-review-step';
@customElement(tagName)
export class LoanReviewStep extends TmBaseComponent {
    @property({ type: Object })
    public loan?: Loan;

    protected render() {
        return html` <tm-section>
                <loan-payment-readonly
                    .loan=${this.loan}
                    .existingPayment=${false}
                ></loan-payment-readonly>
            </tm-section>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Pay loan',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('confirm'));
                        },
                    },
                ]}
            ></tm-footer>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: LoanReviewStep;
    }
}
